import moment from 'moment';

import {
  DAY_OF_WEEK,
  SCHEDULE_DAY_END_HOUR,
  SCHEDULE_END_TIME_OPTIONS,
  SCHEDULE_START_TIME_OPTIONS,
} from '../../../constants';

import type { HourRange } from './types';
import type { DayOfWeek, IChildSchedule } from '../../../types';
import type { ISelectOption, SelectValueType } from '../../../../../../utils/types';

export function isDayOfWeek(value: SelectValueType): value is DayOfWeek {
  return Object.keys(DAY_OF_WEEK).some((day) => day === value);
}

export function getOccupiedHourRangesForDay(
  schedules: ReadonlyArray<IChildSchedule>,
  dayOfWeek: DayOfWeek,
): HourRange[] {
  return schedules
    .filter((schedule) => schedule.day_of_week === dayOfWeek)
    .map((schedule) => {
      const rawEndHour = moment.utc(schedule.schedule_end_date).hour();
      return {
        start: moment.utc(schedule.schedule_start_date).hour(),
        end: rawEndHour === 0 ? SCHEDULE_DAY_END_HOUR : rawEndHour,
      };
    });
}

export function buildScheduleStartTimeOptions(
  occupiedRanges: ReadonlyArray<HourRange>,
): ISelectOption[] {
  return SCHEDULE_START_TIME_OPTIONS.map((option) => ({
    ...option,
    disabled: occupiedRanges.some(
      (range) => option.value >= range.start && option.value < range.end,
    ),
  }));
}

export function buildScheduleEndTimeOptions(
  occupiedRanges: ReadonlyArray<HourRange>,
  startHour: number | '',
): ISelectOption[] {
  return SCHEDULE_END_TIME_OPTIONS.map((option) => {
    let disabled: boolean;
    if (startHour === '') {
      disabled = occupiedRanges.some(
        (range) => option.value > range.start && option.value < range.end,
      );
    } else if (option.value <= startHour) {
      disabled = true;
    } else {
      disabled = occupiedRanges.some(
        (range) => range.start >= startHour && range.start < option.value,
      );
    }
    return { ...option, disabled };
  });
}
